// Shared events data for Calendar and Home pages

export const events = [
  { 
    id: 100, 
    title: 'Smile with Confidence',
    titleES: 'Sonríe con Confianza',
    date: new Date(2025, 8, 1),
    allDay: true,
    category: 'academic',
    description: 'Kick off the month with confidence and a smile! (SEL focus)',
    descriptionES: '¡Comienza el mes con confianza y una sonrisa! (Enfoque SEL)'
  },
  { 
    id: 1, 
    title: 'Spring Art Exhibition', 
    date: new Date(2023, 4, 15), 
    startTime: '9:00 AM',
    endTime: '11:00 AM',
    category: 'academic',
    description: 'Showcasing student artwork inspired by the history of the Bronx.'
  },
  { 
    id: 2, 
    title: 'Parent-Teacher Conference', 
    date: new Date(2023, 4, 20), 
    startTime: '6:00 PM',
    endTime: '8:00 PM',
    category: 'academic',
    description: 'Spring semester review and discussion of student progress.'
  },
  { 
    id: 3, 
    title: 'Memorial Day - School Closed', 
    date: new Date(2023, 4, 25), 
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Memorial Day.'
  },
  { 
    id: 4, 
    title: 'PTA Meeting', 
    date: new Date(2023, 5, 5), 
    startTime: '7:00 PM',
    endTime: '8:30 PM',
    category: 'pta',
    description: 'Monthly PTA meeting to discuss upcoming events and initiatives.'
  },
  { 
    id: 5, 
    title: 'Early Dismissal', 
    date: new Date(2023, 5, 10), 
    endTime: '1:00 PM',
    category: 'earlyDismissal',
    description: 'Students will be dismissed at 1:00 PM for staff development.'
  },
  { 
    id: 6, 
    title: 'End of Year Testing', 
    date: new Date(2023, 5, 15), 
    allDay: true,
    category: 'testing',
    description: 'Final assessments for all grade levels.'
  },
  { 
    id: 7, 
    title: 'Summer Program Registration Deadline', 
    date: new Date(2023, 5, 20), 
    allDay: true,
    category: 'academic',
    description: 'Last day to register for "Summer in the Bronx" program.'
  },
  { 
    id: 8, 
    title: 'Chess Club Tournament', 
    date: new Date(2023, 5, 22), 
    startTime: '3:30 PM',
    endTime: '5:30 PM',
    category: 'afterSchool',
    description: 'Annual chess tournament for all club members. Parents welcome to watch.'
  },

  // --- September 2025 English/Spanish events from flyers ---
  { 
    id: 101, 
    title: 'First Day of School',
    titleES: 'Feliz primer día de clases',
    date: new Date(2025, 8, 4),
    allDay: true,
    category: 'academic',
    description: 'Welcome back! First day of school for all students.',
    descriptionES: '¡Bienvenidos! Primer día de clases para todos los estudiantes.'
  },
  { 
    id: 102, 
    title: 'Scan for Book of the Month',
    titleES: 'Escanea para el Libro del Mes',
    date: new Date(2025, 8, 6),
    allDay: true,
    category: 'academic',
    description: 'Scan the QR on the flyer or visit the Library page to view the Book of the Month.',
    descriptionES: 'Escanee el código QR del volante o visite la página de Biblioteca para ver el Libro del Mes.',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  { 
    id: 103, 
    title: 'International Literacy Day',
    titleES: 'Día Internacional de la Alfabetización',
    date: new Date(2025, 8, 8),
    allDay: true,
    category: 'academic',
    description: 'Celebrate reading and literacy across the world.',
    descriptionES: 'Celebremos la lectura y la alfabetización en todo el mundo.'
  },
  { 
    id: 104, 
    title: 'Start with Hello Week (9/14–9/19)',
    titleES: 'Semana de Bienvenida (14/09–19/09)',
    date: new Date(2025, 8, 14),
    allDay: true,
    category: 'academic',
    description: 'School‑wide kindness activities all week.',
    descriptionES: 'Actividades de amabilidad en toda la escuela durante la semana.'
  },
  { 
    id: 105, 
    title: 'Start with Hello Week',
    titleES: 'Semana de Bienvenida',
    date: new Date(2025, 8, 15),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 106, 
    title: 'Start with Hello Week',
    titleES: 'Semana de Bienvenida',
    date: new Date(2025, 8, 16),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 107, 
    title: 'Start with Hello Week',
    titleES: 'Semana de Bienvenida',
    date: new Date(2025, 8, 17),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 108, 
    title: 'Start with Hello Week',
    titleES: 'Semana de Bienvenida',
    date: new Date(2025, 8, 18),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 109, 
    title: 'Start with Hello Week',
    titleES: 'Semana de Bienvenida',
    date: new Date(2025, 8, 19),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 110, 
    title: 'Hispanic Heritage Month begins (9/15–10/15)',
    titleES: 'Mes de la Herencia Hispana comienza (15/09–15/10)',
    date: new Date(2025, 8, 15),
    allDay: true,
    category: 'academic',
    description: 'Kickoff for Hispanic Heritage Month.',
    descriptionES: 'Inicio del Mes de la Herencia Hispana.'
  },
  { 
    id: 111, 
    title: 'Mexico Independence Day',
    titleES: 'Día de la Independencia de México',
    date: new Date(2025, 8, 16),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 112, 
    title: 'Meet the Teacher Night',
    titleES: 'Noche de Conocer al Maestro',
    date: new Date(2025, 8, 17),
    startTime: '4:00 PM',
    endTime: '7:00 PM',
    category: 'pta',
    description: 'Meet your child’s teachers and learn about the year.',
    descriptionES: 'Conozca a los maestros de su hijo(a) y aprenda sobre el año escolar.'
  },
  { 
    id: 113, 
    title: 'DADS Take Your Child to School Day',
    titleES: '¡Día de Papás: Traiga a Sus Hijos a la Escuela!',
    date: new Date(2025, 8, 18),
    allDay: true,
    category: 'pta',
    description: 'Fathers and father figures accompany students to school.',
    descriptionES: 'Los padres y tutores acompañan a los estudiantes a la escuela.'
  },
  { 
    id: 114, 
    title: 'Climate Action Week (9/21–9/26)',
    titleES: '¡Semana de Acción Climática! (21/09–26/09)',
    date: new Date(2025, 8, 21),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 115, 
    title: 'Climate Action Week',
    titleES: 'Semana de Acción Climática',
    date: new Date(2025, 8, 22),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 116, 
    title: 'Hello, Fall!',
    titleES: '¡Hola otoño!',
    date: new Date(2025, 8, 22),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 117, 
    title: 'Rosh Hashanah — All DOE Schools Closed',
    titleES: 'Rosh Hashaná — ¡Escuelas del DOE cerradas!',
    date: new Date(2025, 8, 23),
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Rosh Hashanah.',
    descriptionES: 'Escuela cerrada en observancia de Rosh Hashaná.'
  },
  { 
    id: 118, 
    title: 'Rosh Hashanah — All DOE Schools Closed',
    titleES: 'Rosh Hashaná — ¡Escuelas del DOE cerradas!',
    date: new Date(2025, 8, 24),
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Rosh Hashanah.',
    descriptionES: 'Escuela cerrada en observancia de Rosh Hashaná.'
  },
  { 
    id: 119, 
    title: 'Climate Action Week',
    titleES: 'Semana de Acción Climática',
    date: new Date(2025, 8, 23),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 120, 
    title: 'Climate Action Week',
    titleES: 'Semana de Acción Climática',
    date: new Date(2025, 8, 24),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 121, 
    title: 'Climate Action Week',
    titleES: 'Semana de Acción Climática',
    date: new Date(2025, 8, 25),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 122, 
    title: 'Coffee with the Principal',
    titleES: 'Café con la Principal',
    date: new Date(2025, 8, 26),
    startTime: '8:30 AM',
    endTime: '9:30 AM',
    category: 'pta',
    location: 'Main Building',
    description: 'Join the Principal for coffee and conversation. Main Building.',
    descriptionES: 'Acompáñenos para café y conversación con la Principal. Edificio Principal.'
  },
  { 
    id: 123, 
    title: 'Climate Action Week',
    titleES: 'Semana de Acción Climática',
    date: new Date(2025, 8, 26),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 124, 
    title: 'Hispanic Heritage Month ends',
    titleES: 'Finaliza el Mes de la Herencia Hispana',
    date: new Date(2025, 9, 15),
    allDay: true,
    category: 'academic'
  }
  ,
  // --- October 2025 English/Spanish events from flyers ---
  { 
    id: 125,
    title: 'National Bullying Prevention Month begins',
    titleES: 'Mes Nacional de la Prevención de Acoso Escolar',
    date: new Date(2025, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'October is National Bullying Prevention Month. School-wide activities throughout the month.',
    descriptionES: 'Octubre es el Mes Nacional de la Prevención del Acoso Escolar. Actividades durante todo el mes.'
  },
  { 
    id: 126,
    title: 'Yom Kippur — All DOE Schools Closed',
    titleES: 'Yom Kippur — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2025, 9, 2),
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Yom Kippur.',
    descriptionES: 'Escuela cerrada en observancia de Yom Kippur.'
  },
  { 
    id: 127,
    title: 'Community Clean Up Friday',
    titleES: '¡Viernes de Limpieza Comunitaria!',
    date: new Date(2025, 9, 3),
    allDay: true,
    category: 'pta'
  },
  { 
    id: 128,
    title: 'Smart Stars Weekly (Invite Only)',
    titleES: 'Smart Stars Semanal (Solo por Invitación)',
    date: new Date(2025, 9, 3),
    allDay: true,
    category: 'afterSchool'
  },
  { 
    id: 129,
    title: 'Scan for Book of the Month',
    titleES: 'Escanea para el Libro del Mes',
    date: new Date(2025, 9, 4),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  { 
    id: 130,
    title: 'Fire Prevention Week (10/05–10/11)',
    titleES: 'Semana de Prevención de Incendios (05/10–11/10)',
    date: new Date(2025, 9, 5),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 131,
    title: 'Grade 1 Tennis Begins',
    titleES: '¡Comienza Tenis para 1.º Grado!',
    date: new Date(2025, 9, 6),
    allDay: true,
    category: 'afterSchool'
  },
  { 
    id: 132,
    title: 'ENL New Families Orientation (Main Building)',
    titleES: 'Orientación para Nuevas Familias de ENL (Edificio Principal)',
    date: new Date(2025, 9, 9),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building'
  },
  { 
    id: 133,
    title: 'Parent Workshop: Raising Kids with Confidence & Respect',
    titleES: 'Taller para Padres: Criando Niños con Confianza y Respeto',
    date: new Date(2025, 9, 10),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building'
  },
  { 
    id: 134,
    title: 'Grade 5 Canoe Trip',
    titleES: 'Excursión en Canoas — 5.º Grado',
    date: new Date(2025, 9, 10),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 135,
    title: "Indigenous Peoples' Day — All DOE Schools Closed",
    titleES: 'Día de los Pueblos Indígenas — ¡Escuelas del DOE cerradas!',
    date: new Date(2025, 9, 13),
    allDay: true,
    category: 'holiday'
  },
  { 
    id: 136,
    title: 'Parent Workshop: Healthy Habits (Main Building)',
    titleES: 'Taller para Padres: Hábitos Saludables (Edificio Principal)',
    date: new Date(2025, 9, 14),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building'
  },
  { 
    id: 137,
    title: 'Kindergarten Trip: Botanical Gardens',
    titleES: 'Salida al Jardín Botánico para Kindergarten',
    date: new Date(2025, 9, 15),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 138,
    title: 'PA Meeting',
    titleES: 'Reunión del Comité de Padres',
    date: new Date(2025, 9, 15),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite'
  },
  { 
    id: 139,
    title: 'PINK DAY — Wear Pink!',
    titleES: '¡DÍA PINK! ¡Usa rosa!',
    date: new Date(2025, 9, 15),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 140,
    title: 'Community Clean Up Friday',
    titleES: '¡Viernes de Limpieza Comunitaria!',
    date: new Date(2025, 9, 17),
    allDay: true,
    category: 'pta'
  },
  { 
    id: 141,
    title: 'Italian Heritage Month',
    titleES: 'Mes de la Herencia Italiana',
    date: new Date(2025, 9, 18),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 142,
    title: 'Diwali — All DOE Schools Closed',
    titleES: 'Diwali — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2025, 9, 20),
    allDay: true,
    category: 'holiday'
  },
  { 
    id: 143,
    title: 'Pajama Day — Put Bullying to Rest',
    titleES: '¡Día de Pijamas! ¡Detén el Acoso Escolar!',
    date: new Date(2025, 9, 21),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 144,
    title: 'CEC Meeting',
    titleES: 'Reunión del CEC',
    date: new Date(2025, 9, 21),
    startTime: '4:00 PM',
    category: 'pta'
  },
  { 
    id: 145,
    title: 'Unity Day — Wear Orange!',
    titleES: 'Día de la unidad — ¡Usa naranja!',
    date: new Date(2025, 9, 22),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 146,
    title: 'Suit Up, Superheroes! Wear Your Favorite Superhero Clothes',
    titleES: '¡Prepárense, Superhéroes! ¡Usa tu ropa de superhéroe favorita!',
    date: new Date(2025, 9, 23),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 147,
    title: 'Sport Your Team Gear! Wear Your Favorite Team',
    titleES: '¡Luce tu ropa de equipo! ¡Usa la ropa de tu equipo favorito!',
    date: new Date(2025, 9, 24),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 148,
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    date: new Date(2025, 9, 27),
    startTime: '4:15 PM',
    category: 'pta'
  },
  { 
    id: 149,
    title: 'Picture Day — Satellite and Main Building',
    titleES: 'Día de Fotos en los Edificios Principal y Satélite',
    date: new Date(2025, 9, 28),
    allDay: true,
    category: 'academic'
  },
  { 
    id: 150,
    title: 'PBIS Rally at the Main Building',
    titleES: 'Rally PBIS en el Edificio Principal',
    date: new Date(2025, 9, 29),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  { 
    id: 151,
    title: 'PBIS Rally at the Satellite Building',
    titleES: 'Rally PBIS en el Edificio Satélite',
    date: new Date(2025, 9, 30),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 152,
    title: "Book O'Ween",
    titleES: "Book O'Ween",
    date: new Date(2025, 9, 31),
    allDay: true,
    category: 'academic'
  },
  // --- November 2025 English/Spanish events from flyers ---
  {
    id: 153,
    title: 'Dental Visit at the Satellite',
    titleES: 'Visita Dental en el Edificio Satélite',
    date: new Date(2025, 10, 3),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 154,
    title: 'Election Day — All DOE Schools are Closed! Virtual PD Day for Staff',
    titleES: 'Día de las Elecciones — ¡Todas las escuelas del DOE están cerradas! Día de Desarrollo Profesional Virtual para el Personal',
    date: new Date(2025, 10, 4),
    allDay: true,
    category: 'holiday',
    description: 'School closed for Election Day. Virtual Professional Development for staff.',
    descriptionES: 'Escuela cerrada por el Día de las Elecciones. Día de Desarrollo Profesional Virtual para el Personal.'
  },
  {
    id: 155,
    title: 'Dental Visit at the Satellite',
    titleES: 'Visita Dental en el Edificio Satélite',
    date: new Date(2025, 10, 5),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 156,
    title: 'Virtual Parent-Teacher Conferences — Session 1: 12:20 p.m. - 7:30 p.m., Session 2: 4:30 p.m. - 7:30 p.m.',
    titleES: 'Conferencias Virtuales de Padres y Maestros — Sesión 1: 12:20 p.m. - 7:30 p.m., Sesión 2: 4:30 p.m. - 7:30 p.m.',
    date: new Date(2025, 10, 6),
    startTime: '12:20 PM',
    endTime: '7:30 PM',
    category: 'pta',
    description: 'Virtual Parent-Teacher Conferences. Two sessions available.',
    descriptionES: 'Conferencias Virtuales de Padres y Maestros. Dos sesiones disponibles.'
  },
  {
    id: 157,
    title: 'Dental Visit at the Satellite',
    titleES: 'Visita Dental en el Edificio Satélite',
    date: new Date(2025, 10, 6),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 158,
    title: 'Parent Workshop: Caring for Ourselves While Raising Kids at Main Building',
    titleES: 'Taller para Padres: Cuidarnos mientras criamos a nuestros hijos en el Edificio Principal',
    date: new Date(2025, 10, 7),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building'
  },
  {
    id: 159,
    title: 'Dental Visit at the Satellite and Main Building',
    titleES: 'Visita Dental en el Edificio Satélite y en el Edificio Principal',
    date: new Date(2025, 10, 7),
    allDay: true,
    category: 'academic',
    location: 'Satellite and Main Building'
  },
  {
    id: 160,
    title: 'Dental Visit at the Main Building',
    titleES: 'Visita Dental en el Edificio Principal',
    date: new Date(2025, 10, 10),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 161,
    title: 'Veterans Day — All DOE Schools are Closed!',
    titleES: 'Día de los Veteranos — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2025, 10, 11),
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Veterans Day.',
    descriptionES: 'Escuela cerrada en observancia del Día de los Veteranos.'
  },
  {
    id: 162,
    title: 'Parent Learning Walk at the Main Building',
    titleES: 'Caminata de Aprendizaje para Padres en el Edificio Principal',
    date: new Date(2025, 10, 12),
    allDay: true,
    category: 'pta',
    location: 'Main Building'
  },
  {
    id: 163,
    title: 'Dental Visit at the Main Building',
    titleES: 'Visita Dental en el Edificio Principal',
    date: new Date(2025, 10, 12),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 164,
    title: 'ENL - New Families Orientation at the Satellite',
    titleES: 'Orientación para Nuevas Familias ENL en el Edificio Satélite',
    date: new Date(2025, 10, 13),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building'
  },
  {
    id: 165,
    title: 'Dental Visit at the Main Building',
    titleES: 'Visita Dental en el Edificio Principal',
    date: new Date(2025, 10, 13),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 166,
    title: 'Dental Visit at the Main Building',
    titleES: 'Visita Dental en el Edificio Principal',
    date: new Date(2025, 10, 14),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 167,
    title: 'Gratitude Gala at the Main Building 3:00 p.m. - 5:00 p.m. (Invite Only)',
    titleES: 'Gala de Gratitud en el Edificio Principal 3:00 p.m. - 5:00 p.m. (Solo con invitación)',
    date: new Date(2025, 10, 17),
    startTime: '3:00 PM',
    endTime: '5:00 PM',
    category: 'academic',
    location: 'Main Building',
    description: 'Gratitude Gala (Invite Only)',
    descriptionES: 'Gala de Gratitud (Solo con invitación)'
  },
  {
    id: 168,
    title: 'SLT meeting',
    titleES: 'Reunión del SLT',
    date: new Date(2025, 10, 17),
    startTime: '4:15 PM',
    category: 'pta'
  },
  {
    id: 169,
    title: 'CEC Meeting at MS 313',
    titleES: 'Reunión del CEC en la escuela MS 313',
    date: new Date(2025, 10, 18),
    startTime: '5:30 PM',
    category: 'pta',
    location: 'MS 313'
  },
  {
    id: 170,
    title: 'Parent Association Meeting at the Satellite',
    titleES: 'Reunión de la Asociación de Padres en el Edificio Satélite',
    date: new Date(2025, 10, 19),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building'
  },
  {
    id: 171,
    title: 'Gratitude Gala at the Satellite 3:00 p.m. - 5:00 p.m. (Invite Only)',
    titleES: 'Gala de Gratitud en el Edificio Satélite 3:00 p.m. - 5:00 p.m. (Solo con invitación)',
    date: new Date(2025, 10, 19),
    startTime: '3:00 PM',
    endTime: '5:00 PM',
    category: 'academic',
    location: 'Satellite Building',
    description: 'Gratitude Gala (Invite Only)',
    descriptionES: 'Gala de Gratitud (Solo con invitación)'
  },
  {
    id: 172,
    title: 'Gratitude Gala at the Satellite 3:00 p.m. - 5:00 p.m. (Invite Only)',
    titleES: 'Gala de Gratitud en el Edificio Satélite 3:00 p.m. - 5:00 p.m. (Solo con invitación)',
    date: new Date(2025, 10, 20),
    startTime: '3:00 PM',
    endTime: '5:00 PM',
    category: 'academic',
    location: 'Satellite Building',
    description: 'Gratitude Gala (Invite Only)',
    descriptionES: 'Gala de Gratitud (Solo con invitación)'
  },
  {
    id: 173,
    title: 'PBIS RALLY at the Satellite Building',
    titleES: 'RALLY PBIS en el Edificio Satélite',
    date: new Date(2025, 10, 21),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 174,
    title: 'Gratitude with the Principal 12:30 PM',
    titleES: 'Gratitud con la Directora 12:30 p.m.',
    date: new Date(2025, 10, 21),
    startTime: '12:30 PM',
    category: 'pta',
    location: 'Satellite Building'
  },
  {
    id: 175,
    title: 'Heroes of Highbridge 2 Mile walk/run',
    titleES: 'Caminata/Carrera "Héroes de Highbridge" 2 millas',
    date: new Date(2025, 10, 22),
    allDay: true,
    category: 'academic',
    description: 'Sign up for the Do Heroes of Highbridge 2 Mile walk/run!',
    descriptionES: '¡Inscríbete para la caminata/carrera "Héroes de Highbridge" de 2 millas!'
  },
  {
    id: 176,
    title: 'Crazy Sock Day',
    titleES: 'Día de Calcetines Locos',
    date: new Date(2025, 10, 24),
    allDay: true,
    category: 'academic'
  },
  {
    id: 177,
    title: 'PBIS RALLY at the Main Building',
    titleES: 'RALLY PBIS en el Edificio Principal',
    date: new Date(2025, 10, 24),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 178,
    title: "Who's That Turkey? Art Reveal!",
    titleES: '¿Quién es ese Pavo? Exhibición de Arte',
    date: new Date(2025, 10, 25),
    allDay: true,
    category: 'academic',
    description: 'Turkey art reveal event',
    descriptionES: 'Exhibición de Arte de Pavo'
  },
  {
    id: 179,
    title: 'Wear Fall Colors!',
    titleES: '¡Vístete con colores de otoño!',
    date: new Date(2025, 10, 26),
    allDay: true,
    category: 'academic'
  },
  {
    id: 180,
    title: 'Community Potluck',
    titleES: 'Comida Comunitaria (Potluck)',
    date: new Date(2025, 10, 26),
    allDay: true,
    category: 'pta'
  },
  {
    id: 181,
    title: 'Thanksgiving Recess — All DOE Schools are Closed!',
    titleES: 'Receso de Acción de Gracias — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2025, 10, 27),
    allDay: true,
    category: 'holiday',
    description: 'Thanksgiving Recess - School closed.',
    descriptionES: 'Receso de Acción de Gracias - Escuela cerrada.'
  },
  {
    id: 182,
    title: 'Thanksgiving Recess — All DOE Schools are Closed!',
    titleES: 'Receso de Acción de Gracias — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2025, 10, 28),
    allDay: true,
    category: 'holiday',
    description: 'Thanksgiving Recess - School closed.',
    descriptionES: 'Receso de Acción de Gracias - Escuela cerrada.'
  },
  {
    id: 183,
    title: 'Scan here for the Book of the Month',
    titleES: 'Escanea aquí para el Libro del Mes',
    date: new Date(2025, 10, 29),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  // --- January 2026 English/Spanish events from flyers ---
  {
    id: 184,
    title: 'Winter Recess — All DOE Schools are Closed!',
    titleES: 'Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 0, 1),
    allDay: true,
    category: 'holiday',
    description: 'Winter Recess - School closed.',
    descriptionES: 'Receso de Invierno - Escuela cerrada.'
  },
  {
    id: 185,
    title: 'Winter Recess — All DOE Schools are Closed!',
    titleES: 'Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 0, 2),
    allDay: true,
    category: 'holiday',
    description: 'Winter Recess - School closed.',
    descriptionES: 'Receso de Invierno - Escuela cerrada.'
  },
  {
    id: 186,
    title: 'Scan here for the Book of the Month',
    titleES: 'Escanea aquí para el Libro del Mes',
    date: new Date(2026, 0, 3),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  {
    id: 187,
    title: 'High-Five Day! Return on 1/5 • Earn 5 Scholar Dollars',
    titleES: '¡Día del Choca esos 5! Regresan el 5 de enero • Ganan 5 Dólares Escolares',
    date: new Date(2026, 0, 5),
    allDay: true,
    category: 'academic',
    description: 'High-Five Day! Students return from break and earn 5 Scholar Dollars.',
    descriptionES: '¡Día del Choca esos 5! Los estudiantes regresan del receso y ganan 5 Dólares Escolares.'
  },
  {
    id: 188,
    title: 'Kindergarten Open House at the Satellite',
    titleES: 'Casa Abierta de Kindergarten en el plantel satélite',
    date: new Date(2026, 0, 6),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Kindergarten Open House at the Satellite Building.',
    descriptionES: 'Casa Abierta de Kindergarten en el plantel satélite.'
  },
  {
    id: 189,
    title: 'Disney Shirt Day! Any Disney, Pixar, Marvel, or Star Wars shirt',
    titleES: '¡Día de Camisa! Cualquier camisa de Disney, Pixar, Marvel o Star Wars',
    date: new Date(2026, 0, 9),
    allDay: true,
    category: 'academic',
    description: 'Wear any Disney, Pixar, Marvel, or Star Wars shirt.',
    descriptionES: 'Usen cualquier camisa de Disney, Pixar, Marvel o Star Wars.'
  },
  {
    id: 190,
    title: 'College and Career Week (01/12–01/16)',
    titleES: '¡Semana Universitaria y de Carreras! (12/01–16/01)',
    date: new Date(2026, 0, 11),
    allDay: true,
    category: 'academic',
    description: 'College and Career Week begins.',
    descriptionES: 'Comienza la Semana Universitaria y de Carreras.'
  },
  {
    id: 191,
    title: 'We are college ready! Wear college gear or colors',
    titleES: '¡Estamos listos para la universidad! Usen ropa o colores universitarios',
    date: new Date(2026, 0, 12),
    allDay: true,
    category: 'academic',
    description: 'College Day - Wear college gear or colors.',
    descriptionES: 'Día Universitario - Usen ropa o colores universitarios.'
  },
  {
    id: 192,
    title: 'Our future is bright! Wear sunglasses and/or bright colors',
    titleES: '¡Nuestro futuro es brillante! Usen lentes de sol y/o colores brillantes',
    date: new Date(2026, 0, 13),
    allDay: true,
    category: 'academic',
    description: 'Bright Future Day - Wear sunglasses and/or bright colors.',
    descriptionES: 'Día del Futuro Brillante - Usen lentes de sol y/o colores brillantes.'
  },
  {
    id: 193,
    title: '3K/Pre-K Application Opens',
    titleES: 'Se abre la solicitud para 3K/Pre-K',
    date: new Date(2026, 0, 14),
    allDay: true,
    category: 'academic',
    description: 'Important Reminder: 3K/Pre-K Application Opens.',
    descriptionES: 'Recordatorio importante: Se abre la solicitud para 3K/Pre-K.'
  },
  {
    id: 194,
    title: 'Career Day Guest Speakers at the Main Building & Satellite',
    titleES: 'Día de Carreras – Oradores Invitados En el edificio principal y el plantel satélite',
    date: new Date(2026, 0, 14),
    allDay: true,
    category: 'academic',
    description: 'Career Day with Guest Speakers at the Main Building and Satellite.',
    descriptionES: 'Día de Carreras con Oradores Invitados en el edificio principal y el plantel satélite.'
  },
  {
    id: 195,
    title: 'Dress as your dream job',
    titleES: 'Vístanse como el trabajo de sus sueños',
    date: new Date(2026, 0, 15),
    allDay: true,
    category: 'academic',
    description: 'Dress as your dream job day.',
    descriptionES: 'Día de vestirse como el trabajo de sus sueños.'
  },
  {
    id: 196,
    title: 'Hats off to College & Career readiness. Wear your favorite hat',
    titleES: '¡Sombreros arriba por la preparación universitaria y de carrera! Usen su sombrero favorito',
    date: new Date(2026, 0, 16),
    allDay: true,
    category: 'academic',
    description: 'Hats off to College & Career readiness. Wear your favorite hat.',
    descriptionES: '¡Sombreros arriba por la preparación universitaria y de carrera! Usen su sombrero favorito.'
  },
  {
    id: 197,
    title: 'SRT Parent Workshop at the Main @ 8:30am (Positive discipline techniques and setting boundaries)',
    titleES: 'Taller para Padres de SRT en el edificio principal a las 8:30 a. m. el 16 de enero (Técnicas de disciplina positiva y establecimiento de límites)',
    date: new Date(2026, 0, 17),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building',
    description: 'SRT Parent Workshop at the Main Building on positive discipline techniques and setting boundaries.',
    descriptionES: 'Taller para Padres de SRT en el edificio principal sobre técnicas de disciplina positiva y establecimiento de límites.'
  },
  {
    id: 198,
    title: 'Rev. Dr. Martin Luther King Jr. Day — All DOE Schools are Closed!',
    titleES: 'Día del Dr. Martin Luther King, Jr. — ¡Todas las escuelas del DOE estarán cerradas!',
    date: new Date(2026, 0, 19),
    allDay: true,
    category: 'holiday',
    description: 'School closed in observance of Rev. Dr. Martin Luther King Jr. Day.',
    descriptionES: 'Escuela cerrada en observancia del Día del Dr. Martin Luther King, Jr.'
  },
  {
    id: 199,
    title: 'Pajama Day – "Dream Big!"',
    titleES: 'Día de Pijamas – "¡Sueña en grande!"',
    date: new Date(2026, 0, 20),
    allDay: true,
    category: 'academic',
    description: 'Pajama Day - Dream Big!',
    descriptionES: 'Día de Pijamas - ¡Sueña en grande!'
  },
  {
    id: 200,
    title: 'CEC at MS 229/PS 274',
    titleES: 'CEC en la escuela MS 229 / PS 274 a las 5:30 p. m.',
    date: new Date(2026, 0, 20),
    startTime: '5:30 PM',
    category: 'pta',
    location: 'MS 229/PS 274',
    description: 'CEC Meeting at MS 229/PS 274.',
    descriptionES: 'Reunión del CEC en la escuela MS 229 / PS 274.'
  },
  {
    id: 201,
    title: 'PA Meeting at the Satellite',
    titleES: 'Reunión de la Asociación de Padres (PA) en el plantel satélite',
    date: new Date(2026, 0, 21),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Parent Association Meeting at the Satellite.',
    descriptionES: 'Reunión de la Asociación de Padres en el plantel satélite.'
  },
  {
    id: 202,
    title: 'Parent Financial Workshop at the Satellite',
    titleES: 'Taller Financiero para Padres en el plantel satélite',
    date: new Date(2026, 0, 21),
    startTime: '9:00 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Parent Financial Workshop at the Satellite.',
    descriptionES: 'Taller Financiero para Padres en el plantel satélite.'
  },
  {
    id: 203,
    title: 'Twin Day! Match with your twin today',
    titleES: '¡Día de Gemelos! Combina tu ropa con tu gemelo hoy',
    date: new Date(2026, 0, 23),
    allDay: true,
    category: 'academic',
    description: 'Twin Day - Match with your twin today.',
    descriptionES: 'Día de Gemelos - Combina tu ropa con tu gemelo hoy.'
  },
  {
    id: 204,
    title: 'Kindergarten application closes',
    titleES: 'Cierra la solicitud para Kindergarten',
    date: new Date(2026, 0, 23),
    allDay: true,
    category: 'academic',
    description: 'Important Reminder: Kindergarten application closes.',
    descriptionES: 'Recordatorio importante: Cierra la solicitud para Kindergarten.'
  },
  {
    id: 205,
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    date: new Date(2026, 0, 26),
    startTime: '4:15 PM',
    category: 'pta',
    description: 'SLT Meeting at 4:15 PM.',
    descriptionES: 'Reunión del SLT a las 4:15 p. m.'
  },
  {
    id: 206,
    title: 'Virtual PBIS Rally',
    titleES: 'Asamblea Virtual de PBIS',
    date: new Date(2026, 0, 29),
    startTime: '9:45 AM',
    category: 'academic',
    description: 'Virtual PBIS Rally at 9:45am.',
    descriptionES: 'Asamblea Virtual de PBIS a las 9:45 a. m.'
  },
  {
    id: 207,
    title: 'Bring your talent to school!',
    titleES: '¡Trae tu talento a la escuela!',
    date: new Date(2026, 0, 30),
    allDay: true,
    category: 'academic',
    description: 'Bring your talent to school day.',
    descriptionES: 'Día de traer tu talento a la escuela.'
  },
  {
    id: 208,
    title: 'Coffee with the Principal',
    titleES: 'Café con la Directora',
    date: new Date(2026, 0, 30),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building',
    description: 'Coffee with the Principal at 8:30 AM at the Main Building.',
    descriptionES: 'Café con la Directora a las 8:30 a. m. en el Edificio Principal.'
  },
  // --- February 2026 English/Spanish events from flyers ---
  {
    id: 209,
    title: 'We Love Our School Counselors - National School Counseling Week February 2-6',
    titleES: '¡Queremos a nuestros consejeros escolares! - Semana Nacional de la Consejería Escolar febrero 2-6',
    date: new Date(2026, 1, 1),
    allDay: true,
    category: 'academic',
    description: 'National School Counseling Week begins. Show appreciation for our school counselors.',
    descriptionES: 'Comienza la Semana Nacional de la Consejería Escolar. Muestra aprecio por nuestros consejeros escolares.'
  },
  {
    id: 210,
    title: 'Groundhog Day',
    titleES: 'Día de la marmota',
    date: new Date(2026, 1, 2),
    allDay: true,
    category: 'academic',
    description: 'Groundhog Day celebration.',
    descriptionES: 'Celebración del Día de la marmota.'
  },
  {
    id: 211,
    title: 'Virtual PTI-Testing Workshop in the Main Building (For Parents)',
    titleES: 'Taller virtual de evaluación para padres - Edificio Principal',
    date: new Date(2026, 1, 3),
    allDay: true,
    category: 'pta',
    location: 'Main Building',
    description: 'Virtual parent workshop on testing in the Main Building.',
    descriptionES: 'Taller virtual de evaluación para padres en el Edificio Principal.'
  },
  {
    id: 212,
    title: 'World Read Aloud Day!',
    titleES: 'Día Mundial de la Lectura en Voz Alta',
    date: new Date(2026, 1, 4),
    allDay: true,
    category: 'academic',
    description: 'Celebrate World Read Aloud Day!',
    descriptionES: '¡Celebra el Día Mundial de la Lectura en Voz Alta!'
  },
  {
    id: 213,
    title: 'Pastable Grade 3 - invited students only',
    titleES: 'Preparación de pasta estudiantes invitados de 3.º grado',
    date: new Date(2026, 1, 5),
    allDay: true,
    category: 'academic',
    description: 'Pasta making activity for invited Grade 3 students only.',
    descriptionES: 'Actividad de preparación de pasta para estudiantes invitados de 3.º grado.'
  },
  {
    id: 214,
    title: 'Wear Neon Day!',
    titleES: 'Día de Neón',
    date: new Date(2026, 1, 6),
    allDay: true,
    category: 'academic',
    description: 'Wear neon colors today!',
    descriptionES: '¡Usa colores de neón hoy!'
  },
  {
    id: 215,
    title: 'Saturday Seed Program',
    titleES: 'Programa de Seed de los Sábados',
    date: new Date(2026, 1, 7),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program.',
    descriptionES: 'Programa de Seed de los Sábados.'
  },
  {
    id: 216,
    title: 'Parent Survey Begins',
    titleES: 'Inicio de la encuesta para padres',
    date: new Date(2026, 1, 8),
    allDay: true,
    category: 'pta',
    description: 'Parent Survey begins. Complete by February 13 for a Parent Prize!',
    descriptionES: 'Inicio de la encuesta para padres. ¡Completa antes del 13 de febrero y gana un premio!'
  },
  {
    id: 217,
    title: 'Respect for All Week February 9-13 - Wear something that represents your culture!',
    titleES: 'Semana del Respeto para Todos (9-13 de febrero) - Viste algo que represente tu cultura',
    date: new Date(2026, 1, 9),
    allDay: true,
    category: 'academic',
    description: 'Respect for All Week begins. Wear something that represents your culture!',
    descriptionES: '¡Semana del Respeto para Todos comienza! Viste algo que represente tu cultura.'
  },
  {
    id: 218,
    title: 'Respect for All Week',
    titleES: 'Semana del Respeto para Todos',
    date: new Date(2026, 1, 10),
    allDay: true,
    category: 'academic'
  },
  {
    id: 219,
    title: 'Virtual PTI-Testing Workshop in the Main Building (For Parents) - Respect our earth and our surroundings - Wear Green!',
    titleES: 'Taller virtual de evaluación para padres - Edificio Principal - ¡Respeta nuestra Tierra y nuestro entorno — viste de verde!',
    date: new Date(2026, 1, 10),
    allDay: true,
    category: 'pta',
    location: 'Main Building',
    description: 'Virtual parent workshop on testing. Also, Respect our earth and our surroundings - Wear Green!',
    descriptionES: 'Taller virtual de evaluación para padres. También, ¡Respeta nuestra Tierra y nuestro entorno — viste de verde!'
  },
  {
    id: 220,
    title: 'Love & Respect Our Trees 3K-4K',
    titleES: 'Amor y respeto por nuestros árboles (3K-4K)',
    date: new Date(2026, 1, 10),
    allDay: true,
    category: 'academic',
    description: 'Love & Respect Our Trees activity for 3K-4K students.',
    descriptionES: 'Actividad Amor y respeto por nuestros árboles para estudiantes de 3K-4K.'
  },
  {
    id: 221,
    title: 'Respect for All Week',
    titleES: 'Semana del Respeto para Todos',
    date: new Date(2026, 1, 11),
    allDay: true,
    category: 'academic'
  },
  {
    id: 222,
    title: 'Love & Respect Our Trees K-1st grade - We honor and respect Black History - Wear Pan African Colors',
    titleES: 'Amor y respeto por nuestros árboles (K-1er grado) - Celebramos y respetamos la Historia Afroamericana — usa colores panafricanos',
    date: new Date(2026, 1, 11),
    allDay: true,
    category: 'academic',
    description: 'Love & Respect Our Trees for K-1st grade. We honor and respect Black History - Wear Pan African Colors.',
    descriptionES: 'Amor y respeto por nuestros árboles (K-1er grado). Celebramos y respetamos la Historia Afroamericana — usa colores panafricanos.'
  },
  {
    id: 223,
    title: 'Respect for All Week',
    titleES: 'Semana del Respeto para Todos',
    date: new Date(2026, 1, 12),
    allDay: true,
    category: 'academic'
  },
  {
    id: 224,
    title: 'Wear rainbow or tie dye',
    titleES: 'Usa colores del arcoíris o tie-dye',
    date: new Date(2026, 1, 12),
    allDay: true,
    category: 'academic',
    description: 'Wear rainbow or tie dye colors today.',
    descriptionES: 'Usa colores del arcoíris o tie-dye hoy.'
  },
  {
    id: 225,
    title: 'Respect for All Week',
    titleES: 'Semana del Respeto para Todos',
    date: new Date(2026, 1, 13),
    allDay: true,
    category: 'academic'
  },
  {
    id: 226,
    title: 'Dress in Red & Pink, show Love & Respect to our Bronx Trees',
    titleES: 'Vístete de rojo y rosa, muestra amor y respeto por nuestros árboles del Bronx',
    date: new Date(2026, 1, 13),
    allDay: true,
    category: 'academic',
    description: 'Dress in Red & Pink, show Love & Respect to our Bronx Trees.',
    descriptionES: 'Vístete de rojo y rosa, muestra amor y respeto por nuestros árboles del Bronx.'
  },
  {
    id: 227,
    title: 'HAPPY VALENTINE\'S DAY',
    titleES: 'FELIZ DÍA DE SAN VALENTÍN',
    date: new Date(2026, 1, 14),
    allDay: true,
    category: 'academic',
    description: 'Happy Valentine\'s Day!',
    descriptionES: '¡Feliz Día de San Valentín!'
  },
  {
    id: 228,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 15),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 229,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 16),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 230,
    title: 'Math Winter Break Academy by invitation only',
    titleES: 'Academia de Matemáticas de Invierno — solo con invitación',
    date: new Date(2026, 1, 17),
    allDay: true,
    category: 'academic',
    description: 'Math Winter Break Academy - by invitation only.',
    descriptionES: 'Academia de Matemáticas de Invierno — solo con invitación.'
  },
  {
    id: 231,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 17),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 232,
    title: 'Math Winter Break Academy by invitation only',
    titleES: 'Academia de Matemáticas de Invierno — solo con invitación',
    date: new Date(2026, 1, 18),
    allDay: true,
    category: 'academic',
    description: 'Math Winter Break Academy - by invitation only.',
    descriptionES: 'Academia de Matemáticas de Invierno — solo con invitación.'
  },
  {
    id: 233,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 18),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 234,
    title: 'Math Winter Break Academy by invitation only',
    titleES: 'Academia de Matemáticas de Invierno — solo con invitación',
    date: new Date(2026, 1, 19),
    allDay: true,
    category: 'academic',
    description: 'Math Winter Break Academy - by invitation only.',
    descriptionES: 'Academia de Matemáticas de Invierno — solo con invitación.'
  },
  {
    id: 235,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 19),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 236,
    title: 'Math Winter Break Academy by invitation only',
    titleES: 'Academia de Matemáticas de Invierno — solo con invitación',
    date: new Date(2026, 1, 20),
    allDay: true,
    category: 'academic',
    description: 'Math Winter Break Academy - by invitation only.',
    descriptionES: 'Academia de Matemáticas de Invierno — solo con invitación.'
  },
  {
    id: 237,
    title: 'Mid-Winter Recess — All DOE Schools are Closed!',
    titleES: 'Mid Receso de Invierno — ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 1, 20),
    allDay: true,
    category: 'holiday',
    description: 'Mid-Winter Recess - All DOE Schools are Closed!',
    descriptionES: 'Mid Receso de Invierno - ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 238,
    title: 'SLT Meeting',
    titleES: 'Reunión del SLT',
    date: new Date(2026, 1, 23),
    startTime: '4:15 PM',
    category: 'pta',
    description: 'SLT Meeting at 4:15pm.',
    descriptionES: 'Reunión del SLT a las 4:15 p. m.'
  },
  {
    id: 239,
    title: 'Love & Respect Our Trees 2 & 3rd grades',
    titleES: 'Amor y respeto por nuestros árboles (2-3 grado)',
    date: new Date(2026, 1, 24),
    allDay: true,
    category: 'academic',
    description: 'Love & Respect Our Trees activity for 2nd and 3rd grade students.',
    descriptionES: 'Actividad Amor y respeto por nuestros árboles para estudiantes de 2.º y 3.º grado.'
  },
  {
    id: 240,
    title: 'PA Meeting & Title 1 - 8:30AM - Main Building',
    titleES: 'Reunión del PA — 8:30 a. m., Edificio Principal',
    date: new Date(2026, 1, 25),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building',
    description: 'Parent Association Meeting & Title 1 at 8:30 AM in the Main Building.',
    descriptionES: 'Reunión de la Asociación de Padres y Título 1 a las 8:30 a. m. en el Edificio Principal.'
  },
  {
    id: 241,
    title: 'Love & Respect Our Trees 4th grades',
    titleES: 'Amor y respeto por nuestros árboles (4.º grado)',
    date: new Date(2026, 1, 25),
    allDay: true,
    category: 'academic',
    description: 'Love & Respect Our Trees activity for 4th grade students.',
    descriptionES: 'Actividad Amor y respeto por nuestros árboles para estudiantes de 4.º grado.'
  },
  {
    id: 242,
    title: 'K-1 Families Parent Learning Walk in the Satellite Building',
    titleES: 'Familias de K-1 - Recorrido de Aprendizaje para Padres en el Edificio Satélite',
    date: new Date(2026, 1, 26),
    allDay: true,
    category: 'pta',
    location: 'Satellite Building',
    description: 'K-1 Families Parent Learning Walk in the Satellite Building.',
    descriptionES: 'Familias de K-1 - Recorrido de Aprendizaje para Padres en el Edificio Satélite.'
  },
  {
    id: 243,
    title: 'Red, White, Blue - Dominican Pride shines Through',
    titleES: 'Rojo, blanco y azul — ¡El orgullo dominicano brilla!',
    date: new Date(2026, 1, 27),
    allDay: true,
    category: 'academic',
    description: 'Celebrate Dominican Pride - Wear Red, White, and Blue!',
    descriptionES: '¡Celebra el orgullo dominicano — usa rojo, blanco y azul!'
  },
  {
    id: 244,
    title: '3K/Pre-K Application Closes',
    titleES: 'Cierre de solicitudes 3K/Pre-K',
    date: new Date(2026, 1, 27),
    allDay: true,
    category: 'academic',
    description: 'Important Reminder: 3K/Pre-K Application Closes.',
    descriptionES: 'Recordatorio importante: Cierre de solicitudes 3K/Pre-K.'
  },
  {
    id: 245,
    title: 'Saturday Seed Program Resumes',
    titleES: 'Vuelve el programa de Seed de los Sábados',
    date: new Date(2026, 1, 28),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program Resumes.',
    descriptionES: 'Vuelve el programa de Seed de los Sábados.'
  },
  {
    id: 246,
    title: 'CEC Meeting at PS 170',
    titleES: 'Reunión del CEC en PS 170',
    date: new Date(2026, 1, 25),
    startTime: '5:30 PM',
    category: 'pta',
    location: 'PS 170',
    description: 'CEC Meeting at PS 170 at 5:30pm.',
    descriptionES: 'Reunión del CEC en la escuela PS 170 a las 5:30 p. m.'
  },
  {
    id: 247,
    title: 'Scan here for the Book of the Month',
    titleES: 'Escanea aquí para el Libro del Mes',
    date: new Date(2026, 1, 1),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  {
    id: 248,
    title: 'Black History Month',
    titleES: 'Mes de la Historia Afroamericana',
    date: new Date(2026, 1, 1),
    allDay: true,
    category: 'academic',
    description: 'February is Black History Month.',
    descriptionES: 'Febrero es el Mes de la Historia Afroamericana.'
  },
  {
    id: 249,
    title: 'SEL Word of the Month is RESPECT',
    titleES: 'La palabra SEL del mes es: RESPETO',
    date: new Date(2026, 1, 1),
    allDay: true,
    category: 'academic',
    description: 'SEL Word of the Month: RESPECT',
    descriptionES: 'La palabra SEL del mes es: RESPETO'
  },
  {
    id: 250,
    title: 'Spirit Fridays in February!',
    titleES: '¡Viernes de Espíritu!',
    date: new Date(2026, 1, 6),
    allDay: true,
    category: 'academic',
    description: 'Spirit Fridays throughout February!',
    descriptionES: '¡Viernes de Espíritu en febrero!'
  },
  {
    id: 251,
    title: 'Spirit Fridays in February!',
    titleES: '¡Viernes de Espíritu!',
    date: new Date(2026, 1, 13),
    allDay: true,
    category: 'academic',
    description: 'Spirit Fridays throughout February!',
    descriptionES: '¡Viernes de Espíritu en febrero!'
  },
  {
    id: 252,
    title: 'Spirit Fridays in February!',
    titleES: '¡Viernes de Espíritu!',
    date: new Date(2026, 1, 20),
    allDay: true,
    category: 'academic',
    description: 'Spirit Fridays throughout February!',
    descriptionES: '¡Viernes de Espíritu en febrero!'
  },
  {
    id: 253,
    title: 'Spirit Fridays in February!',
    titleES: '¡Viernes de Espíritu!',
    date: new Date(2026, 1, 27),
    allDay: true,
    category: 'academic',
    description: 'Spirit Fridays throughout February!',
    descriptionES: '¡Viernes de Espíritu en febrero!'
  },
  // ==================== MARCH 2026 ====================
  {
    id: 254,
    title: 'School Social Work Week (March 1–7)',
    titleES: 'Feliz Semana del Trabajo Social Escolar (1–7 de marzo de 2026)',
    date: new Date(2026, 2, 1),
    allDay: true,
    category: 'academic',
    description: 'Happy School Social Work Week! March 1–7, 2026.',
    descriptionES: 'Feliz Semana del Trabajo Social Escolar. 1–7 de marzo de 2026.'
  },
  {
    id: 255,
    title: 'NYPL – Highbridge Book Tastings, Grades 2nd & 3rd',
    titleES: 'NYPL – Highbridge – Degustación de libros, Grados 2 y 3',
    date: new Date(2026, 2, 2),
    allDay: true,
    category: 'academic',
    description: 'NYPL Highbridge Book Tastings for Grades 2nd & 3rd.',
    descriptionES: 'NYPL – Highbridge – Degustación de libros para Grados 2 y 3.'
  },
  {
    id: 256,
    title: 'Summer Rising Application Opens!',
    titleES: 'Abren las inscripciones de Summer Rising',
    date: new Date(2026, 2, 3),
    allDay: true,
    category: 'academic',
    description: 'Summer Rising Application Opens!',
    descriptionES: 'Abren las inscripciones de Summer Rising.'
  },
  {
    id: 257,
    title: 'Simulation Testing ELA – Grades 3, 4, 5 Day 1',
    titleES: 'Simulacro de examen de ELA – Grados 3, 4 y 5 Día 1',
    date: new Date(2026, 2, 3),
    allDay: true,
    category: 'testing',
    description: 'Simulation Testing ELA Grades 3, 4, 5 Day 1.',
    descriptionES: 'Simulacro de examen de ELA – Grados 3, 4 y 5 Día 1.'
  },
  {
    id: 258,
    title: 'PA Meeting & Title 1 – 8:30AM – Satellite Building',
    titleES: 'Reunión de la Asociación de Padres (PA) en el plantel satélite a las 8:30 a. m.',
    date: new Date(2026, 2, 4),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Parent Association Meeting & Title 1 at 8:30 AM in the Satellite Building.',
    descriptionES: 'Reunión de la Asociación de Padres y Título 1 a las 8:30 a. m. en el plantel satélite.'
  },
  {
    id: 259,
    title: 'Happy Holi',
    titleES: 'Feliz Holi',
    date: new Date(2026, 2, 4),
    allDay: true,
    category: 'holiday',
    description: 'Happy Holi!',
    descriptionES: '¡Feliz Holi!'
  },
  {
    id: 260,
    title: 'Simulation Testing ELA – Grades 3, 4, 5 Day 2',
    titleES: 'Simulacro de examen de ELA – Grados 3, 4 y 5 Día 2',
    date: new Date(2026, 2, 4),
    allDay: true,
    category: 'testing',
    description: 'Simulation Testing ELA Grades 3, 4, 5 Day 2.',
    descriptionES: 'Simulacro de examen de ELA – Grados 3, 4 y 5 Día 2.'
  },
  {
    id: 261,
    title: 'Half Day of School – Dismissal at 11:10am',
    titleES: 'Medio día de clases – Salida a las 11:10 a. m.',
    date: new Date(2026, 2, 5),
    allDay: true,
    category: 'earlyDismissal',
    description: 'Half Day of School. Dismissal at 11:10 AM.',
    descriptionES: 'Medio día de clases. Salida a las 11:10 a. m.'
  },
  {
    id: 262,
    title: 'Virtual Parent-Teacher Conferences – Session 1',
    titleES: 'Conferencias Virtuales de Padres y Maestros – Sesión 1',
    date: new Date(2026, 2, 5),
    startTime: '12:20 PM',
    endTime: '2:20 PM',
    category: 'pta',
    description: 'Virtual Parent-Teacher Conferences Session 1: 12:20 PM – 2:20 PM.',
    descriptionES: 'Conferencias Virtuales de Padres y Maestros – Sesión 1: 12:20 p. m. – 2:20 p. m.'
  },
  {
    id: 263,
    title: 'Virtual Parent-Teacher Conferences – Session 2',
    titleES: 'Conferencias Virtuales de Padres y Maestros – Sesión 2',
    date: new Date(2026, 2, 5),
    startTime: '4:30 PM',
    endTime: '7:30 PM',
    category: 'pta',
    description: 'Virtual Parent-Teacher Conferences Session 2: 4:30 PM – 7:30 PM.',
    descriptionES: 'Conferencias Virtuales de Padres y Maestros – Sesión 2: 4:30 p. m. – 7:30 p. m.'
  },
  {
    id: 264,
    title: '100% Attendance Friday!',
    titleES: '¡Viernes de 100% Asistencia!',
    date: new Date(2026, 2, 6),
    allDay: true,
    category: 'academic',
    description: '100% Attendance Friday!',
    descriptionES: '¡Viernes de 100% Asistencia!'
  },
  {
    id: 265,
    title: 'NYPL – Highbridge Book Tastings, Grades K & 1st',
    titleES: 'NYPL – Highbridge – Degustación de libros, Grados K y 1',
    date: new Date(2026, 2, 6),
    allDay: true,
    category: 'academic',
    description: 'NYPL Highbridge Book Tastings for Grades K & 1st.',
    descriptionES: 'NYPL – Highbridge – Degustación de libros para Grados K y 1.'
  },
  {
    id: 266,
    title: 'Wear Purple for Women\'s History Month',
    titleES: 'Viste de morado para el Mes de la Historia de la Mujer',
    date: new Date(2026, 2, 6),
    allDay: true,
    category: 'academic',
    description: 'Wear purple for Women\'s History Month!',
    descriptionES: '¡Viste de morado para el Mes de la Historia de la Mujer!'
  },
  {
    id: 267,
    title: 'Saturday Seed Program',
    titleES: 'Programa de Seed de los Sábados',
    date: new Date(2026, 2, 7),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program.',
    descriptionES: 'Programa de Seed de los Sábados.'
  },
  {
    id: 268,
    title: 'Table of Kingz Crowning',
    titleES: 'Mesa de la Coronación de Reyes',
    date: new Date(2026, 2, 7),
    allDay: true,
    category: 'academic',
    description: 'Table of Kingz Crowning.',
    descriptionES: 'Mesa de la Coronación de Reyes.'
  },
  {
    id: 269,
    title: 'Daylight Saving Time Begins',
    titleES: 'Comienza el horario de verano',
    date: new Date(2026, 2, 8),
    allDay: true,
    category: 'holiday',
    description: 'Daylight Saving Time Begins.',
    descriptionES: 'Comienza el horario de verano.'
  },
  {
    id: 270,
    title: 'NYPL – Highbridge Book Tastings, Grades 4th & 5th',
    titleES: 'NYPL – Highbridge – Degustación de libros, Grados 4 y 5',
    date: new Date(2026, 2, 9),
    allDay: true,
    category: 'academic',
    description: 'NYPL Highbridge Book Tastings for Grades 4th & 5th.',
    descriptionES: 'NYPL – Highbridge – Degustación de libros para Grados 4 y 5.'
  },
  {
    id: 271,
    title: 'For Parents – Testing Workshop (Grades 3–5)',
    titleES: 'Para padres – Taller de preparación para exámenes (grados 3–5)',
    date: new Date(2026, 2, 10),
    allDay: true,
    category: 'pta',
    description: 'For Parents: Testing Workshop for Grades 3–5.',
    descriptionES: 'Para padres: Taller de preparación para exámenes (grados 3–5).'
  },
  {
    id: 272,
    title: 'Simulation Testing Math – Grades 3, 4, 5 Day 1',
    titleES: 'Simulacro de examen de Matemáticas – Grados 3, 4 y 5 Día 1',
    date: new Date(2026, 2, 10),
    allDay: true,
    category: 'testing',
    description: 'Simulation Testing Math Grades 3, 4, 5 Day 1.',
    descriptionES: 'Simulacro de examen de Matemáticas – Grados 3, 4 y 5 Día 1.'
  },
  {
    id: 273,
    title: 'Highbridge Hearts and Hands – By Invite Only',
    titleES: 'Highbridge Hearts and Hands – Solo por invitación',
    date: new Date(2026, 2, 11),
    allDay: true,
    category: 'academic',
    description: 'Highbridge Hearts and Hands – By invite only.',
    descriptionES: 'Highbridge Hearts and Hands – Solo por invitación.'
  },
  {
    id: 274,
    title: 'Simulation Testing Math – Grades 3, 4, 5 Day 2',
    titleES: 'Simulacro de examen de Matemáticas – Grados 3, 4 y 5 Día 2',
    date: new Date(2026, 2, 11),
    allDay: true,
    category: 'testing',
    description: 'Simulation Testing Math Grades 3, 4, 5 Day 2.',
    descriptionES: 'Simulacro de examen de Matemáticas – Grados 3, 4 y 5 Día 2.'
  },
  {
    id: 275,
    title: '100% Attendance Friday!',
    titleES: '¡Viernes de 100% Asistencia!',
    date: new Date(2026, 2, 13),
    allDay: true,
    category: 'academic',
    description: '100% Attendance Friday!',
    descriptionES: '¡Viernes de 100% Asistencia!'
  },
  {
    id: 276,
    title: 'Saturday Seed Program',
    titleES: 'Programa de Seed de los Sábados',
    date: new Date(2026, 2, 14),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program.',
    descriptionES: 'Programa de Seed de los Sábados.'
  },
  {
    id: 277,
    title: 'SLT Meeting',
    titleES: 'Reunión de SLT',
    date: new Date(2026, 2, 16),
    startTime: '4:15 PM',
    category: 'pta',
    description: 'SLT Meeting at 4:15 PM.',
    descriptionES: 'Reunión de SLT a las 4:15 p. m.'
  },
  {
    id: 278,
    title: 'Happy St. Patrick\'s Day – Wear Something Green!',
    titleES: 'Feliz día de San Patricio – ¡Viste algo verde!',
    date: new Date(2026, 2, 17),
    allDay: true,
    category: 'holiday',
    description: 'Happy St. Patrick\'s Day! Wear something green!',
    descriptionES: '¡Feliz día de San Patricio! ¡Viste algo verde!'
  },
  {
    id: 279,
    title: 'CEC Meeting',
    titleES: 'Reunión del CEC',
    date: new Date(2026, 2, 17),
    startTime: '5:30 PM',
    category: 'pta',
    description: 'CEC Meeting at 5:30 PM.',
    descriptionES: 'Reunión del CEC a las 5:30 p. m.'
  },
  {
    id: 280,
    title: 'Highbridge Hearts and Hands – By Invite Only',
    titleES: 'Highbridge Hearts and Hands – Solo por invitación',
    date: new Date(2026, 2, 18),
    allDay: true,
    category: 'academic',
    description: 'Highbridge Hearts and Hands – By invite only.',
    descriptionES: 'Highbridge Hearts and Hands – Solo por invitación.'
  },
  {
    id: 281,
    title: 'PA Meeting & Title 1 – 8:30AM – Main Building',
    titleES: 'Reunión del PA – 8:30 a. m., Edificio Principal',
    date: new Date(2026, 2, 18),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Main Building',
    description: 'Parent Association Meeting & Title 1 at 8:30 AM in the Main Building.',
    descriptionES: 'Reunión de la Asociación de Padres y Título 1 a las 8:30 a. m. en el Edificio Principal.'
  },
  {
    id: 282,
    title: 'Happy Eid al-Fitr – All DOE Schools are Closed!',
    titleES: '¡Feliz Eid al-Fitr! – ¡Todas las escuelas del DOE están cerradas!',
    date: new Date(2026, 2, 20),
    allDay: true,
    category: 'holiday',
    description: 'Happy Eid al-Fitr! All DOE Schools are Closed!',
    descriptionES: '¡Feliz Eid al-Fitr! ¡Todas las escuelas del DOE están cerradas!'
  },
  {
    id: 283,
    title: 'No Saturday Seed Program',
    titleES: 'No Programa de los Sábados',
    date: new Date(2026, 2, 21),
    allDay: true,
    category: 'afterSchool',
    description: 'No Saturday Seed Program this week.',
    descriptionES: 'No hay Programa de los Sábados esta semana.'
  },
  {
    id: 284,
    title: 'Saturday Seed Program',
    titleES: 'Programa de Seed de los Sábados',
    date: new Date(2026, 2, 21),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program.',
    descriptionES: 'Programa de Seed de los Sábados.'
  },
  {
    id: 285,
    title: 'Summer Rising Application Closes!',
    titleES: 'Cierran las inscripciones de Summer Rising',
    date: new Date(2026, 2, 21),
    allDay: true,
    category: 'academic',
    description: 'Summer Rising Application Closes!',
    descriptionES: '¡Cierran las inscripciones de Summer Rising!'
  },
  {
    id: 286,
    title: 'Let\'s Show Math Love This Week',
    titleES: 'Demostremos amor por las matemáticas esta semana',
    date: new Date(2026, 2, 23),
    allDay: true,
    category: 'academic',
    description: 'Let\'s Show Math Love This Week!',
    descriptionES: '¡Demostremos amor por las matemáticas esta semana!'
  },
  {
    id: 287,
    title: 'For Parents – Testing Workshop (Grades 3rd–5th)',
    titleES: 'Para padres – Taller de preparación para exámenes (grados 3–5)',
    date: new Date(2026, 2, 24),
    allDay: true,
    category: 'pta',
    description: 'For Parents: Testing Workshop for Grades 3rd–5th.',
    descriptionES: 'Para padres: Taller de preparación para exámenes (grados 3–5).'
  },
  {
    id: 288,
    title: 'Highbridge Hearts and Hands – By Invite Only',
    titleES: 'Highbridge Hearts and Hands – Solo por invitación',
    date: new Date(2026, 2, 25),
    allDay: true,
    category: 'academic',
    description: 'Highbridge Hearts and Hands – By invite only.',
    descriptionES: 'Highbridge Hearts and Hands – Solo por invitación.'
  },
  {
    id: 289,
    title: 'World Math Day',
    titleES: 'Día Mundial de las Matemáticas',
    date: new Date(2026, 2, 25),
    allDay: true,
    category: 'academic',
    description: 'World Math Day!',
    descriptionES: '¡Día Mundial de las Matemáticas!'
  },
  {
    id: 290,
    title: 'PBIS Rally at the Satellite Building',
    titleES: 'Rally PBIS en el Edificio Satélite',
    date: new Date(2026, 2, 26),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building',
    description: 'PBIS Rally at the Satellite Building.',
    descriptionES: 'Rally PBIS en el Edificio Satélite.'
  },
  {
    id: 291,
    title: 'Learning Walk – Grades 2nd & 3rd',
    titleES: 'Recorrido de aprendizaje – grados 2 y 3',
    date: new Date(2026, 2, 26),
    allDay: true,
    category: 'academic',
    description: 'Learning Walk for Grades 2nd & 3rd.',
    descriptionES: 'Recorrido de aprendizaje para grados 2 y 3.'
  },
  {
    id: 292,
    title: 'EID Celebration',
    titleES: 'Celebración de Eid',
    date: new Date(2026, 2, 26),
    allDay: true,
    category: 'holiday',
    description: 'EID Celebration.',
    descriptionES: 'Celebración de Eid.'
  },
  {
    id: 293,
    title: 'PBIS Rally at the Main Building',
    titleES: 'Rally PBIS en el Edificio Principal',
    date: new Date(2026, 2, 27),
    allDay: true,
    category: 'academic',
    location: 'Main Building',
    description: 'PBIS Rally at the Main Building.',
    descriptionES: 'Rally PBIS en el Edificio Principal.'
  },
  {
    id: 294,
    title: 'Coffee with the Principal – 8:30AM Satellite Building',
    titleES: 'Café con la Directora – 8:30 a. m. Edificio Satélite',
    date: new Date(2026, 2, 27),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Coffee with the Principal at 8:30 AM in the Satellite Building.',
    descriptionES: 'Café con la Directora a las 8:30 a. m. en el Edificio Satélite.'
  },
  {
    id: 295,
    title: 'Saturday Program',
    titleES: 'Programa de los Sábados',
    date: new Date(2026, 2, 28),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Program.',
    descriptionES: 'Programa de los Sábados.'
  },
  {
    id: 296,
    title: 'Saturday Seed Program',
    titleES: 'Programa de Seed de los Sábados',
    date: new Date(2026, 2, 28),
    allDay: true,
    category: 'afterSchool',
    description: 'Saturday Seed Program.',
    descriptionES: 'Programa de Seed de los Sábados.'
  },
  {
    id: 297,
    title: 'Palm Sunday',
    titleES: 'Feliz Domingo de Ramos',
    date: new Date(2026, 2, 29),
    allDay: true,
    category: 'holiday',
    description: 'Palm Sunday.',
    descriptionES: 'Feliz Domingo de Ramos.'
  },
  {
    id: 298,
    title: 'Scan here for the Book of the Month',
    titleES: 'Escanea aquí para el Libro del Mes',
    date: new Date(2026, 2, 31),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  {
    id: 299,
    title: 'SEL Word of the Month is RESILIENCE',
    titleES: 'La palabra SEL del mes es: RESILIENCIA',
    date: new Date(2026, 2, 1),
    allDay: true,
    category: 'academic',
    description: 'SEL Word of the Month: RESILIENCE',
    descriptionES: 'La palabra SEL del mes es: RESILIENCIA'
  },
  {
    id: 300,
    title: 'Women\'s History Month',
    titleES: 'Mes de la Historia de la Mujer',
    date: new Date(2026, 2, 1),
    allDay: true,
    category: 'academic',
    description: 'March is Women\'s History Month.',
    descriptionES: 'Marzo es el Mes de la Historia de la Mujer.'
  },
  {
    id: 301,
    title: 'March Marathon',
    titleES: 'Maratón de Marzo',
    date: new Date(2026, 2, 1),
    allDay: true,
    category: 'academic',
    description: 'March Marathon!',
    descriptionES: '¡Maratón de Marzo!'
  },
  // ==================== OCTOBER 2026 ====================
  {
    id: 302,
    title: 'SEL Word of the Month is UNITY',
    titleES: 'La palabra SEL del mes es: UNIDAD',
    date: new Date(2026, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'SEL Word of the Month: UNITY',
    descriptionES: 'La palabra SEL del mes es: UNIDAD'
  },
  {
    id: 303,
    title: 'Hispanic Heritage Month (September 15 – October 15)',
    titleES: 'Mes de la Herencia Hispana (15 de septiembre al 15 de octubre)',
    date: new Date(2026, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'Hispanic Heritage Month runs September 15 – October 15.',
    descriptionES: 'El Mes de la Herencia Hispana es del 15 de septiembre al 15 de octubre.'
  },
  {
    id: 304,
    title: 'Italian Heritage Month',
    titleES: 'Mes de la Herencia Italiana',
    date: new Date(2026, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'October is Italian Heritage Month.',
    descriptionES: 'Octubre es el Mes de la Herencia Italiana.'
  },
  {
    id: 305,
    title: 'National Bullying Prevention Month',
    titleES: 'Mes Nacional de la Prevención del Acoso Escolar',
    date: new Date(2026, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'October is National Bullying Prevention Month.',
    descriptionES: 'Octubre es el Mes Nacional de la Prevención del Acoso Escolar.'
  },
  {
    id: 306,
    title: 'Hawk Tales – Write a Story About Our Mascot',
    titleES: 'Hawk Tales – Escribe una historia sobre nuestra mascota',
    date: new Date(2026, 9, 1),
    allDay: true,
    category: 'academic',
    description: 'P.S. 11X students: write a story about our mascot! The winning story will be published as a real book.',
    descriptionES: 'Estudiantes de la P.S. 11X: ¡escriban una historia sobre nuestra mascota! La historia ganadora se publicará como un libro de verdad.'
  },
  {
    id: 307,
    title: 'Wear Something That Represents a Hispanic Country',
    titleES: 'Usa algo que represente a un país hispano',
    date: new Date(2026, 9, 2),
    allDay: true,
    category: 'academic',
    description: 'Wear something that represents a Hispanic country.',
    descriptionES: 'Usa algo que represente a un país hispano.'
  },
  {
    id: 308,
    title: 'Wave Makers Swim Program – Grade 2',
    titleES: 'Programa de natación Wave Makers – Segundo grado',
    date: new Date(2026, 9, 2),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Friday: Wave Makers Swim Program for Grade 2.',
    descriptionES: 'Todos los viernes: Programa de natación Wave Makers para segundo grado.'
  },
  {
    id: 309,
    title: 'Scan here for the Book of the Month',
    titleES: 'Escanea aquí para el Libro del Mes',
    date: new Date(2026, 9, 3),
    allDay: true,
    category: 'academic',
    link: '/library',
    image: '/assets/images/calendar/qrcode1.png',
    imageAlt: 'QR code for Book of the Month'
  },
  {
    id: 310,
    title: 'Fire Prevention Week (10/04–10/10)',
    titleES: 'Semana de Prevención de Incendios (04/10–10/10)',
    date: new Date(2026, 9, 4),
    allDay: true,
    category: 'academic'
  },
  {
    id: 311,
    title: 'Fall in Love with Reading All Month Long!',
    titleES: '¡Enamórense de la lectura todo el mes!',
    date: new Date(2026, 9, 5),
    allDay: true,
    category: 'academic',
    description: 'Fall in love with reading all month long!',
    descriptionES: '¡Enamórense de la lectura todo el mes!'
  },
  {
    id: 312,
    title: 'Tennis Program – Grade 1',
    titleES: 'Programa de tenis – Primer grado',
    date: new Date(2026, 9, 5),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Monday: Tennis Program for Grade 1.',
    descriptionES: 'Todos los lunes: Programa de tenis para primer grado.'
  },
  {
    id: 313,
    title: 'Rocket Day!',
    titleES: '¡Día de los Cohetes!',
    date: new Date(2026, 9, 8),
    allDay: true,
    category: 'academic'
  },
  {
    id: 314,
    title: 'Bring in a Flag from a Hispanic Country',
    titleES: 'Trae una bandera de un país hispano',
    date: new Date(2026, 9, 9),
    allDay: true,
    category: 'academic',
    description: 'Bring in a flag from a Hispanic country.',
    descriptionES: 'Trae una bandera de un país hispano.'
  },
  {
    id: 315,
    title: 'Wave Makers Swim Program – Grade 2',
    titleES: 'Programa de natación Wave Makers – Segundo grado',
    date: new Date(2026, 9, 9),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Friday: Wave Makers Swim Program for Grade 2.',
    descriptionES: 'Todos los viernes: Programa de natación Wave Makers para segundo grado.'
  },
  {
    id: 316,
    title: 'Get Your Library Card!',
    titleES: '¡Consiga su tarjeta de biblioteca!',
    date: new Date(2026, 9, 10),
    allDay: true,
    category: 'academic',
    description: 'Get your New York Public Library card!',
    descriptionES: '¡Consiga su tarjeta de la Biblioteca Pública de Nueva York!'
  },
  {
    id: 317,
    title: 'Indigenous Peoples\' Day – All DOE Schools Closed',
    titleES: 'Día de los Pueblos Indígenas – Todas las escuelas del DOE están cerradas',
    date: new Date(2026, 9, 12),
    allDay: true,
    category: 'holiday',
    description: 'Indigenous Peoples\' Day. All DOE schools are closed.',
    descriptionES: 'Día de los Pueblos Indígenas. Todas las escuelas del DOE están cerradas.'
  },
  {
    id: 318,
    title: 'Wear Pink! Walk Highbridge for Breast Cancer Awareness',
    titleES: '¡Vístete de rosa! Camina por Highbridge para concienciar sobre el cáncer de mama',
    date: new Date(2026, 9, 13),
    allDay: true,
    category: 'academic',
    description: 'Wear pink and walk Highbridge for Breast Cancer Awareness.',
    descriptionES: 'Vístete de rosa y camina por Highbridge para concienciar sobre el cáncer de mama.'
  },
  {
    id: 319,
    title: 'Middle School Applications Open',
    titleES: 'Abren las solicitudes para la escuela intermedia',
    date: new Date(2026, 9, 14),
    allDay: true,
    category: 'academic',
    description: 'Middle School Applications open today.',
    descriptionES: 'Hoy abren las solicitudes para la escuela intermedia.'
  },
  {
    id: 320,
    title: 'Workshop: Parent\'s Guide to Personal Safety & Crime Prevention (Virtual ZOOM, 6:00 PM)',
    titleES: 'Taller: Guía para padres sobre seguridad personal y prevención del delito (virtual por ZOOM, 6:00 p. m.)',
    date: new Date(2026, 9, 14),
    startTime: '6:00 PM',
    category: 'pta',
    description: 'Virtual ZOOM workshop at 6:00 PM: Parent\'s Guide to Personal Safety & Crime Prevention.',
    descriptionES: 'Taller virtual por ZOOM a las 6:00 p. m.: Guía para padres sobre seguridad personal y prevención del delito.'
  },
  {
    id: 321,
    title: 'P.S. 11X Filming – Wear School Swag!',
    titleES: 'P.S. 11X: Grabación – ¡Lleva ropa o accesorios de la escuela!',
    date: new Date(2026, 9, 15),
    allDay: true,
    category: 'academic',
    description: 'P.S. 11X filming day. Wear school swag!',
    descriptionES: 'Día de grabación en la P.S. 11X. ¡Lleva ropa o accesorios de la escuela!'
  },
  {
    id: 322,
    title: '5th Grade Canoe Trip',
    titleES: 'Excursión en canoa de 5.º grado',
    date: new Date(2026, 9, 16),
    allDay: true,
    category: 'academic',
    description: '5th Grade Canoe Trip.',
    descriptionES: 'Excursión en canoa de 5.º grado.'
  },
  {
    id: 323,
    title: 'Wear Spooky Socks!',
    titleES: '¡Ponte calcetines de miedo!',
    date: new Date(2026, 9, 16),
    allDay: true,
    category: 'academic',
    description: 'Wear spooky socks!',
    descriptionES: '¡Ponte calcetines de miedo!'
  },
  {
    id: 324,
    title: 'Wave Makers Swim Program – Grade 2',
    titleES: 'Programa de natación Wave Makers – Segundo grado',
    date: new Date(2026, 9, 16),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Friday: Wave Makers Swim Program for Grade 2.',
    descriptionES: 'Todos los viernes: Programa de natación Wave Makers para segundo grado.'
  },
  {
    id: 325,
    title: 'Unity Spirit Week (October 19–23)',
    titleES: 'Semana del Espíritu de Unidad (19–23 de octubre de 2026)',
    date: new Date(2026, 9, 19),
    allDay: true,
    category: 'academic',
    description: 'Unity Spirit Week, October 19–23, 2026.',
    descriptionES: 'Semana del Espíritu de Unidad, del 19 al 23 de octubre de 2026.'
  },
  {
    id: 326,
    title: 'Say "Hey" Day – Wear Yellow',
    titleES: 'Día de decir «Hola» – Viste de amarillo',
    date: new Date(2026, 9, 19),
    allDay: true,
    category: 'academic',
    description: 'Say "Hey" Day! Wear yellow to kick off the week with a smile.',
    descriptionES: 'Día de decir «Hola»: viste de amarillo para empezar la semana con una sonrisa.'
  },
  {
    id: 327,
    title: 'Tennis Program – Grade 1',
    titleES: 'Programa de tenis – Primer grado',
    date: new Date(2026, 9, 19),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Monday: Tennis Program for Grade 1.',
    descriptionES: 'Todos los lunes: Programa de tenis para primer grado.'
  },
  {
    id: 328,
    title: 'Pajama Day',
    titleES: 'Día de la Pijama',
    date: new Date(2026, 9, 20),
    allDay: true,
    category: 'academic',
    description: 'Wear your comfy pajamas and put bullying to rest.',
    descriptionES: 'Ponte tu pijama cómoda y pon el bullying a dormir.'
  },
  {
    id: 329,
    title: 'Wear Orange! (Unity Day)',
    titleES: '¡Vístanse de naranja! (Día de la Unidad)',
    date: new Date(2026, 9, 21),
    allDay: true,
    category: 'academic',
    description: 'Wear orange for Unity Day!',
    descriptionES: '¡Vístanse de naranja para el Día de la Unidad!'
  },
  {
    id: 330,
    title: 'PA Meeting – 8:30AM – Satellite Building',
    titleES: 'Reunión de la Asociación de Padres a las 8:30 a. m. (Satélite)',
    date: new Date(2026, 9, 21),
    startTime: '8:30 AM',
    category: 'pta',
    location: 'Satellite Building',
    description: 'Parent Association Meeting at 8:30 AM in the Satellite Building.',
    descriptionES: 'Reunión de la Asociación de Padres a las 8:30 a. m. en el plantel satélite.'
  },
  {
    id: 331,
    title: 'Superhero Day',
    titleES: 'Día de Superhéroes',
    date: new Date(2026, 9, 22),
    allDay: true,
    category: 'academic',
    description: 'Wear a super hero gear/clothes and be someone\'s hero when you stand up for bullying.',
    descriptionES: 'Usa ropa de superhéroe y conviértete en el héroe de alguien cuando defiendas el acoso escolar.'
  },
  {
    id: 332,
    title: 'Wear Your Team Gear',
    titleES: 'Usa la ropa de tu equipo',
    date: new Date(2026, 9, 23),
    allDay: true,
    category: 'academic',
    description: 'Wear your team gear to show that when we work together, kindness always wins.',
    descriptionES: 'Usa la ropa de tu equipo para demostrar que cuando trabajamos juntos, la amabilidad siempre triunfa.'
  },
  {
    id: 333,
    title: 'Wave Makers Swim Program – Grade 2',
    titleES: 'Programa de natación Wave Makers – Segundo grado',
    date: new Date(2026, 9, 23),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Friday: Wave Makers Swim Program for Grade 2.',
    descriptionES: 'Todos los viernes: Programa de natación Wave Makers para segundo grado.'
  },
  {
    id: 334,
    title: 'PBIS Rally at the Satellite Building',
    titleES: 'Rally PBIS en el Edificio Satélite',
    date: new Date(2026, 9, 26),
    allDay: true,
    category: 'academic',
    location: 'Satellite Building'
  },
  {
    id: 335,
    title: 'Enter the Hawk Tales Writing Contest!',
    titleES: '¡Inscríbete en el concurso de escritura Hawk Tales!',
    date: new Date(2026, 9, 26),
    allDay: true,
    category: 'academic',
    description: 'Enter the Hawk Tales writing contest!',
    descriptionES: '¡Inscríbete en el concurso de escritura Hawk Tales!'
  },
  {
    id: 336,
    title: 'Tennis Program – Grade 1',
    titleES: 'Programa de tenis – Primer grado',
    date: new Date(2026, 9, 26),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Monday: Tennis Program for Grade 1.',
    descriptionES: 'Todos los lunes: Programa de tenis para primer grado.'
  },
  {
    id: 337,
    title: 'Enter the Hawk Tales Writing Contest!',
    titleES: '¡Inscríbete en el concurso de escritura Hawk Tales!',
    date: new Date(2026, 9, 27),
    allDay: true,
    category: 'academic',
    description: 'Enter the Hawk Tales writing contest!',
    descriptionES: '¡Inscríbete en el concurso de escritura Hawk Tales!'
  },
  {
    id: 338,
    title: 'PBIS Rally at the Main Building',
    titleES: 'Rally PBIS en el Edificio Principal',
    date: new Date(2026, 9, 28),
    allDay: true,
    category: 'academic',
    location: 'Main Building'
  },
  {
    id: 339,
    title: 'Enter the Hawk Tales Writing Contest!',
    titleES: '¡Inscríbete en el concurso de escritura Hawk Tales!',
    date: new Date(2026, 9, 28),
    allDay: true,
    category: 'academic',
    description: 'Enter the Hawk Tales writing contest!',
    descriptionES: '¡Inscríbete en el concurso de escritura Hawk Tales!'
  },
  {
    id: 340,
    title: 'Enter the Hawk Tales Writing Contest!',
    titleES: '¡Inscríbete en el concurso de escritura Hawk Tales!',
    date: new Date(2026, 9, 29),
    allDay: true,
    category: 'academic',
    description: 'Enter the Hawk Tales writing contest!',
    descriptionES: '¡Inscríbete en el concurso de escritura Hawk Tales!'
  },
  {
    id: 341,
    title: 'Fall Festival Attendance Initiative',
    titleES: 'Iniciativa de asistencia al festival de otoño',
    date: new Date(2026, 9, 30),
    allDay: true,
    category: 'academic',
    description: 'Fall Festival Attendance Initiative.',
    descriptionES: 'Iniciativa de asistencia al festival de otoño.'
  },
  {
    id: 342,
    title: 'Dress Up as a Book Character',
    titleES: 'Disfrázate de un personaje de libro',
    date: new Date(2026, 9, 30),
    allDay: true,
    category: 'academic',
    description: 'Dress up as a book character (Book-o-ween)!',
    descriptionES: '¡Disfrázate de un personaje de libro (Book-o-ween)!'
  },
  {
    id: 343,
    title: 'Wave Makers Swim Program – Grade 2',
    titleES: 'Programa de natación Wave Makers – Segundo grado',
    date: new Date(2026, 9, 30),
    allDay: true,
    category: 'afterSchool',
    description: 'Every Friday: Wave Makers Swim Program for Grade 2.',
    descriptionES: 'Todos los viernes: Programa de natación Wave Makers para segundo grado.'
  }
];

export default events;


